import type { GameDefinition } from "../game";
import {
  CONNECT_FOUR_ACTIONS,
  connectFour,
} from "./environment";
import { ConnectFourRenderer } from "./renderer";
import type { ConnectFourState } from "./types";

export const connectFourDefinition: GameDefinition<ConnectFourState> = {
  gameId: "connect-four",
  gameName: "Connect Four",
  variantId: "standard",
  variantName: "Standard 6×7",
  board: { width: 7, height: 6 },
  observationShape: [6, 7, 3],
  actionCount: CONNECT_FOUR_ACTIONS,
  defaultSimulations: 32,
  defaultHumanPlayer: 1,
  modelIds: [
    "dry-vortex-25-v7",
    "dry-vortex-25-v6",
  ],
  playerNames: ["Red", "Yellow"],
  controls: {},
  createEnvironment: () => connectFour,
  createRenderer: () => new ConnectFourRenderer(),
  createInferenceInput: (state) => ({
    observation: connectFour.observe(state),
    legalActionMask: connectFour.legalActionMask(state),
  }),
  statusText: (state) => {
    if (state.terminalReason === "win") {
      return `${state.winner === 0 ? "Red" : "Yellow"} wins`;
    }
    if (state.terminalReason === "draw") return "Draw · board full";
    if (state.terminalReason === "illegal-action") {
      return "Game over · illegal action";
    }
    return `${state.currentPlayer === 0 ? "Red" : "Yellow"} to move`;
  },
  moveHistory: (state) => state.moves.map((move) => move.label),
};

export {
  CONNECT_FOUR_ACTIONS,
  CONNECT_FOUR_COLUMNS,
  CONNECT_FOUR_MAX_STEPS,
  CONNECT_FOUR_ROWS,
  PgxConnectFour,
  connectFour,
} from "./environment";
export { ConnectFourRenderer } from "./renderer";
export type {
  ConnectFourMove,
  ConnectFourState,
  ConnectFourTerminalReason,
} from "./types";
